var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.b()},[_c('div',{class:_vm.b('body')},[_c('div',{class:_vm.b('title')},[_vm._v(_vm._s(_vm.stage.name))]),_c('div',{class:_vm.b('subtitle')},[_vm._v(_vm._s(_vm.stage.dealsCount)+" Negociaciones")])]),_c('div',{class:_vm.b('amount')},[_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.stage.creditAmount,_vm.currency)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }